

<div class="container py-4" *ngIf="procedimientosEnLista.length >0">
    <p class=" text-center fs-2 fw-bold" style="color:var(--primary-color);">Procedimientos</p>

  <div class="container px-4 py-2" id="icon-grid">

    <div class="row row-cols-1 row-cols-sm-2 row-cols-md-3 row-cols-lg-5 g-5 py-5 justify-content-center ">
      <div class="col d-flex align-items-center " *ngFor="let procedimiento of procedimientosEnLista">
        <i style="color: var(--secondary-color); font-size: 10px" class=" bi bi-circle-fill px-2"></i>
        <div>
          <h3 class=" mb-0 fs-6  ">{{ procedimiento }}</h3>
        </div>
      </div>

    </div>
  </div>
</div>
